// this is an older version of the reducer in /shared/reducers,
// still relevant to the kiosk for now but can be reconciled by changing items to an object.
import {
  SET_PHOTOSWIPE_OPEN,
  SET_PHOTOSWIPE_INDEX,
  SET_PHOTOSWIPE_MOMENT,
  SET_PHOTOSWIPE_ITEMS,
  SHOW_AUTHORIZE_KNOCKOUT,
  SHOW_CROP_MOMENT,
  SET_DRAGGABLE_IMAGE,
  SET_PHOTOSWIPE_HIDDEN,
} from 'shared/actions/types';

import {
  SHOW_PRINT_SIZE_EDITS
} from 'app/actions/types';

import produce from 'immer';

const initialState = {
  open: false,
  index: 0,
  momentId: null,
  purchased: false,
  items: [],
  authorizeKnockOutVisible: false,
  reKnockOutMomentId: 0,
  cropMomentVisible: false,
  cropMomentSrc: '',
  cropMomentId: 0,
  cropMoment: null,
  dragImageEnabled: false,
  printSizeEditsVisible: false,
  selectedPrintSize: null,
  restore: false
}

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_PHOTOSWIPE_OPEN:
      return produce(state, draft => {
        draft.open = action.payload;
      });

    case SET_PHOTOSWIPE_HIDDEN:
      return produce(state, draft => {
        if (action.payload == true) {
          draft.open = false
          draft.restore = state.open
        } else {
          draft.open = state.restore;
        }
      });

    case SET_PHOTOSWIPE_INDEX:
      return produce(state, draft => {
        draft.index = action.payload;
        draft.momentId = null;
      });

    case SET_PHOTOSWIPE_MOMENT:
      return produce(state, draft => {
        draft.momentId = action.payload.id;
        draft.purchased = action.payload.purchased;
        draft.index = null;
      });

    case SET_PHOTOSWIPE_ITEMS:
      return produce(state, draft => {
        draft.items = action.payload;
      });

    case SHOW_AUTHORIZE_KNOCKOUT:
      return produce(state, draft => {
        draft.authorizeKnockOutVisible = action.payload.visible;
        draft.reKnockOutMomentId = action.payload.reknockout_moment_id
      });

    case SHOW_CROP_MOMENT:
      return produce(state, draft => {
        draft.cropMomentVisible = action.payload.visible;
        draft.cropMomentSrc = action.payload.crop_moment_src;
        draft.cropMomentId = action.payload.crop_moment_id;
        draft.cropMoment = action.payload.crop_moment
      });

    case SET_DRAGGABLE_IMAGE:
      return produce(state, draft => {
        draft.dragImageEnabled = action.payload;
      });

    case SHOW_PRINT_SIZE_EDITS:
      return produce(state, draft => {
        draft.printSizeEditsVisible = action.payload.visible;
        draft.cropMomentSrc = action.payload.crop_moment_src;
        draft.cropMomentId = action.payload.crop_moment_id;
        draft.cropMoment = action.payload.crop_moment;
      });

    default:
      return state;
  }
}
